import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'app-unlock-button',
  standalone: true,
  imports: [MatButton, TranslatePipe],
  templateUrl: './unlock-button.component.html',
  styleUrls: ['./unlock-button.component.scss'],
})
export class UnlockButtonComponent {
  @Input() isProcessing = false;
}
